import { useEffect } from 'react';
import classNames from 'classnames';

import ArrowRightIcon from '@svg/arrows-right.svg';
import { useHeaderState } from '@hook/useHeaderState';
import { useDesktopOrWider } from '@utils/mediaQuery';
import { Button } from '@ui/Button';
import { Image } from '@ui/Image';
import { UserMenuLinks, UserMenuLink } from '@components/UserMenuLinks';

import s from './HeaderUserMenu.sss';

export { UserMenuLink } from '@components/UserMenuLinks';

interface User {
  username: string,
  avatar?: string | null,
  unreadMessagesCount: number,
  hasUnreadNotifications?: boolean | null,
  isSeller: boolean,
}

interface Props {
  user: User,
  links: UserMenuLink[],
}

export const HeaderUserMenu: React.FC<Props> = ({
  user,
  links,
}) => {
  const isDesktop = useDesktopOrWider();

  const {
    isHeaderUserMenuOpen,
    handleCloseHeaderUserMenu,
    handleToggleHeaderUserMenu,
  } = useHeaderState();

  // Close on any click & scroll
  useEffect(
    () => {
      if (isDesktop) {
        window.addEventListener('click', handleCloseHeaderUserMenu);
        window.addEventListener('scroll', handleCloseHeaderUserMenu, { passive: true });
      }

      return () => {
        window.removeEventListener('click', handleCloseHeaderUserMenu);
        window.removeEventListener('scroll', handleCloseHeaderUserMenu);
      };
    },
    [handleCloseHeaderUserMenu, isDesktop],
  );

  const handleToggleMenu = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    handleToggleHeaderUserMenu();
  };

  return (
    <div className={s.root}>
      <Button
        className={s.button}
        theme='text'
        onClick={handleToggleMenu}
      >
        <Image
          className={s.avatar}
          src={user.avatar || '#'}
          width='40'
          height='40'
          alt="avatar"
        />
        <ArrowRightIcon
          className={classNames(
            s.arrow,
            { [s.arrowStateOpen]: isHeaderUserMenuOpen },
          )}
          width='18'
          height='18'
        />
      </Button>

      <div
        className={classNames(
          s.dropdownOuter,
          { [s.dropdownOpened]: isHeaderUserMenuOpen },
        )}
      >
        <UserMenuLinks links={links} />
      </div>
    </div>
  );
};
